<template>
    <div>
        <AppDialog
            closeable
            @close="closeDialog"
            :title="
                !userData.free_plan
                    ? $t('pages_pricing_creditPack_moreInputs_title')
                    : $t('pages_pricing_creditPack_notEnoughCredit_title')
            "
            v-if="showMoreInputsDialog"
            :show="showMoreInputsDialog"
        >
            <div class="lg:w-[540px]">
                <template v-if="!userData.free_plan">
                    <div class="flex lg:flex-row flex-col lg:gap-2 gap-4">
                        <template v-for="(item, idx) in items">
                            <div
                                class="py-6 transition-all space-y-2 px-4 border-2 w-full rounded-lg lg:text-center text-start cursor-pointer"
                                :class="
                                    activeItemIndex === idx ? 'border-brand-400 bg-brand-500/40' : 'border-gray-850'
                                "
                                @click="activeItemIndex = idx"
                            >
                                <div class="flex lg:flex-col flex-row items-center gap-2 lg:mb-0 mb-4">
                                    <NuxtImg class="lg:mx-auto" :src="item.image" width="32" height="32" />
                                    <p class="lg:text-title-sm text-white text-body-lg font-bold">{{ item.title }}</p>
                                </div>
                                <p class="text-body-md text-gray-400">{{ item.description }}</p>
                            </div>
                        </template>
                    </div>

                    <AppButton block class="mt-8" size="lg" @click="handleContinue"> Continue </AppButton>
                </template>

                <template v-else>
                    <AppNotEnoughCredit @upgrade="upgradePlan" @cancel="closeDialog" />
                </template>
            </div>
        </AppDialog>
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";

const { showMoreInputsDialog } = storeToRefs(usePricingStore());

function closeDialog() {
    showMoreInputsDialog.value = false;
}

const { userData } = storeToRefs(useUserStore());

interface IItem {
    title: string;
    description: string;
    image: string;
    value: "credit-pack" | "upgrade";
}

const activeItemIndex = ref(0);

const { t } = useI18n();

const items: IItem[] = [
    {
        title: t("pages_pricing_getMorePhotos"),
        image: "https://revi.rvstatic.com/revivoto-design-system/coins/gold-lg.png",
        value: "credit-pack",
        description: t("pages_pricing_creditPack_moreInputs_desc"),
    },
    {
        title: t("global_upgrade"),
        image: "/svg/upgrade.svg",
        value: "upgrade",
        description: t("pages_pricing_creditPack_upgrade_desc"),
    },
];

const localePath = useLocalePath();

const emit = defineEmits(["click:continue"]);

function upgradePlan() {
    closeDialog();
    return navigateTo(localePath("/pricing"));
}

function handleContinue() {
    const activeItem = items[activeItemIndex.value];
    if (activeItem.value === "upgrade") {
        closeDialog();
        return navigateTo(localePath("/pricing"));
    } else {
        closeDialog();
        emit("click:continue");
    }
}
</script>
